import { render } from "./NotificationsNav.vue?vue&type=template&id=72087ab1"
import script from "./NotificationsNav.vue?vue&type=script&lang=js"
export * from "./NotificationsNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__